<template>
  <div class="addpersonInfo">
    <div class="top">
      <el-button type="primary" plain @click="back">返回</el-button>
    </div>
    <div class="content clearfix">
      <div class="right">
        <el-form ref="form" :model="form" :inline="true" label-width="120px">
          <div class="my-table">
            <div class="my-title fl">填写手机号码，邀请指定用户加入企业</div>
            <div v-for="(item, $index) in form.list" :key="$index" class="clear" style="margin-top:10px;">
              <device-info :index="$index" :device-info="item" :list="form.list" @removeComponent="removeComponent" @addComponent="addComponent" :type="1" :addType="addType"></device-info>
            </div>
          </div>
        </el-form>
        <div class="submitReportBox">
          <el-button :loading="lodinging" type="primary" @click="submitReport('form')" >确认邀请</el-button >
        </div>
      </div>
    </div>
    <el-dialog v-dialogDrag v-if="professionDialogVisible" :visible.sync="professionDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handlePofessionClose" title="邀请成功" custom-class="profession-dialog" width="500px" >
      <span>
        <p style="text-align: center;">已将邀请链接以短信的形式发送至受邀用户</p>
        <p style="text-align: center;">您还可以复制邀请链接后以其他方式发送至用户</p>
        <p style="text-align: center;margin-top:20px">
          <el-button type="primary" @click="confirmAddSpec" >复制邀请链接</el-button >
        </p>
      </span>
    </el-dialog>
    <Vcode :show="isShow" :canvas-width="349" :canvas-height="209" class="vue-puzzle-vcodeone" @success="onSuccess" @close="onclose"/>
  </div>
</template>

<script>
import deviceInfo from "@/views/components/invitePeople";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import Vcode from "vue-puzzle-vcode";
import { mapState } from "vuex";
import { baseUrlWeb}from "@/utils"
export default {
  components: {
    deviceInfo,
    Vcode
  },
  data() {
    var telephone1 = (rule, value, callback) => {
      const {phoneReg} = this
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneReg.test(value)) {
        callback(new Error("手机号格式错误!"));
      } else {
        callback();
      }
    };
    var neiwaibu2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择人员类别"));
      } else {
        callback();
      }
    };
    var bumen = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择供方公司"));
      } else {
        callback();
      }
    };
    return {
      form: {
        list: [
          {
            phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              bumen: { trigger: "change", validator: bumen },
            }
          }
        ]
      },
      form1: {
        list: [
          {
            phone: "",
            neiwaibu: "",
            bumen: "",
            bumenid: "",
            rules: {
              telephone: { trigger: "change", validator: telephone1 },
              neiwaibu1: { trigger: "change", validator: neiwaibu2 },
              bumen: { trigger: "change", validator: bumen },
            }
          }
        ]
      },
      lodinging: false,
      professionDialogVisible: false,
      lianjie: "",
      isShow: false, // 验证码模态框是否出现
      datalist: [],
      join1:require('@/CommonDP/assets/addpersonInfo/join1.png'),
      addp: require('@/CommonDP/assets/addpersonInfo/addp.png'),
      join2: require('@/CommonDP/assets/addpersonInfo/协同小助手.png'),
      repeat: '',
      repeat2: "",
      phoneReg:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      addType:'0'
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    })
  },
  created() {
    const {addType,LeftAllData} = this.$route.query
    if (LeftAllData) this.LeftAllData = JSON.parse(LeftAllData)
    this.addType = addType
    const {list} = this.form
    const {list:list1} = this.form1
    list[0].neiwaibu = this.addType
    list1[0].neiwaibu = this.addType
    console.log(typeof addType);
    // addType === '0' ? this.$route.meta.prouteName = '内部人员' : this.$route.meta.prouteName = '成员管理'
    // console.log(this.$route.meta.prouteName);
  },
  methods: {
    back() {
      this.addType === '0' ? this.$router.push({name:'personInfo'}) : this.$router.push({name:'supperManage'});
    },
    addComponent(index) {
      var ii = index + 1;
      var ll = this.form.list.length;
      if (ll == ii) {
        var telephone1 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入手机号"));
          } else if (!/^1[3-9]\d{9}$/.test(value)) {
            callback(new Error("手机号格式错误!"));
          } else {
            this.repeat = callback
            this.repeat2 = value
            this.querymo()
          }
        };
        var neiwaibu2 = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择人员类别"));
          } else {
            callback();
          }
        };
        var bumen = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请选择供方公司"));
          } else {
            callback();
          }
        };
        this.form.list.push({
          phone: "",
          neiwaibu:this.addType,
          bumen: "",
          bumenid: "",
          rules: {
            telephone: { trigger: "change", validator: telephone1 },
            neiwaibu1: { trigger: "change", validator: neiwaibu2 },
            bumen: { trigger: "change", validator: bumen }
          }
        });
      }
    },
    querymo() {
      var encoded = encodeURI(this.repeat2);
      var pilots = this.form.list
      const rebels = pilots.filter(pilot => pilot.phone === encoded);
      if (rebels.length >= 2) {
        this.repeat(new Error('手机号不能重复'))
      } else {
        this.repeat()
      }
    },
    removeComponent(index) {
      this.form.list.splice(index, 1);
    },

    submitReport(formName) {
      this.lianjie = "";
      const phones = this.form.list.filter(item => item.phone !== "");
      const neiwaibus = this.form.list.filter(item => item.neiwaibu !== "");
      const {phoneReg} = this
      if (phones.length || neiwaibus.length) {
        var data = [];
        this.form.list.forEach((value, key) => {
          if (value.phone) {
            if (!value.neiwaibu) {
              this.$refs.form.validateField("list." + key + ".neiwaibu");
            } else if (!phoneReg.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.bumen&&this.addType==="1") {
              this.$refs.form.validateField("list." + key + ".bumen");
            } else {
              var tt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid
              };
              data.push(tt);
            }
          } else if (value.neiwaibu) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!phoneReg.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!value.bumen&&this.addType==="1") {
              this.$refs.form.validateField("list." + key + ".bumen");
            } else {
              var ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid
              };
              data.push(ttt);
            }
          }else if (value.bumen) {
            if (!value.phone) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else if (!phoneReg.test(value.phone)) {
              this.$refs.form.validateField("list." + key + ".phone");
            } else {
              var ttt = {
                phone: value.phone,
                isExternal: value.neiwaibu,
                deptIds: value.bumenid
              };
              data.push(ttt);
            }
          }
        });
        console.log(data, "提交");
        if (data.length >= 1) {
          console.log("调添加接口");
          this.isShow = true;
          this.datalist = data;
        }
      } else {
        this.$message({
          duration: 1000,
          message: "最少加一人",
          type: "warning"
        });
      }
    },
    onSuccess() {
      this.isShow = false;
      this.lodinging = true;
      var params = {
        enterpriseId: this.enterpriseId,
        userList: this.datalist,
      };
      systemPersonService.enterpriseGeteInviCode(params).then(res => {
        if (res.result == "0") {
          this.professionDialogVisible = true;
          this.lianjie = res.data;
          this.lodinging = false;
          this.form = this.form1;
          this.$nextTick(() => {
            this.$refs["form"].resetFields();
          });
        }
      }).catch(() => {
        this.lodinging = false;
      });
    },
    handlePofessionClose() {
      this.professionDialogVisible = false;
    },
    confirmAddSpec() {
      var code = "";
      code = baseUrlWeb()+ "/joinEnterprise?code=" + this.lianjie;
      this.$copyText(code).then(res => {
        this.professionDialogVisible = false;
        this.$message.success("链接复制成功！");
      });
    },
    onclose() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.addpersonInfo {
  height: calc(100% - 96px);
  min-width:1540px;
  .top{
    height:57px;
    line-height:57px;
    border-bottom:1px solid #d3d9e8c4;
    padding-left:18px
  }
  .content{
    background: #F4F5FA;
    border-radius: 4px;
    margin-left:18px;
    margin-right:18px;
    height:100%;
    margin-top:19px;
  }
  .my-table .btn-table {
    left: 28px;
    width: calc(100% - 28px);
  }
  .el-button--small {
    width: auto;
  }
  .my-form .el-input__inner,
  .my-table .el-input__inner {
    width: 160px;
    height: 30px;
    line-height: 30px;
  }
  .detail-info .el-input__inner {
    width: 480px;
  }
  .el-textarea__inner {
    width: 625px;
  }
  .el-form-item__content{
    height: 40px;
  }
  .left{
    float: left;
    .join1{
      margin-top:147px;
      margin-left:136px
    }
    .addp{
      margin-top:73px;
      margin-left:61px
    }
    .join2{
      margin-top:40px;
      margin-left:198px
    }
  }
  .right{
    float: left;
    margin-left:100px;
    width: 852px;
    /deep/ .el-input__inner{
      width: 246px!important;
    }
    /deep/ .el-form-item{
      margin-bottom:15px
    }
  }
  .clearfix:after{ /* 正常浏览器 清除浮动 */
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix{
    *zoom: 1; /* zoom 1 就是ie6 清除浮动的方法 * 是ie7以下的版本所识别 */
  }
  .my-title{
    font-size:18px;
    margin-top:45px;
    margin-bottom:20px
  }
  .submitReportBox{
    text-align: right;
    margin-right: 86px;
  }

}
</style>
<style>
.vue-puzzle-vcodeone {
  z-index: 9999!important;
}
</style>
